export class Constants {
    //public static readonly baseUrl = "https://localhost:7007";

    public static readonly baseUrl = "https://mitdotnetapi.smartranserp.com";

    public static readonly baseImageUrl = "https://mitwebsiteartifacts.s3.amazonaws.com/";

    public static readonly mitLogoUrl = "https://mitwebsiteartifacts.s3.ap-south-1.amazonaws.com/logo/update-mitimage.png";
    
    public static readonly webURL = "https://mitresource.com" ;
}
